import { Base } from './_base';

export class PlaybackBackend extends Base {
  constructor(item) {
    super(item);
  }
}
